// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"0c4d4cdc","181":"ef141bf6","455":"c3ed2d33","977":"2085140f"}[chunkId] + ".chunk.js";
};